import { RootState } from '../store'

export const dictionarySelector = (state: RootState) => {
  const { dictionary } = state

  return dictionary
}
